import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { HttpStatusCode } from "axios";
import { CustomError } from "../api/CustomError";
import { _get } from "../api/apiClient";
import { CustomSuccess } from "../api/CustomSuccess";

export const fetchFISubscriptionPrivileges = createAsyncThunk(
  "fetch_fi_subscription_privileges",
  async ({ orguid }, thunkAPI) => {
    try {
      const config = {
        successMessage: "Fetched financial institutions subscriptions.",
        errorMessage: "Failed to fetch financial institutions subscriptions.!",
      };

      const response = await _get(`${orguid}/privileges`);

      if (response?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }

      const { data, error, message, status, statusCode, responseType } =
        CustomSuccess(response, {
          ...config,
          disableToast: true,
        });

      await thunkAPI.dispatch(setSubscriptionPrivileges(data));

      return {
        data,
        error,
        message,
        status,
        statusCode,
        responseType,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

const privilegesSlice = createSlice({
  name: "privileges_slice",
  initialState: {
    list: [],
    rbacPrivileges: [],
    subscriptionPrivileges: [],
    FISubscriptionPrivileges: null,
  },
  reducers: {
    setRbacPrivileges: (state, action) => {
      if (typeof action.payload === "string") {
        state.rbacPrivileges = action.payload.split(",").map((p) => p.trim());
      } else if (Array.isArray(action.payload)) {
        state.rbacPrivileges = action.payload;
      }
    },
    setSubscriptionPrivileges: (state, action) => {
      if (typeof action.payload === "string") {
        state.subscriptionPrivileges = action.payload
          .split(",")
          .map((p) => p.trim());
      } else if (Array.isArray(action.payload)) {
        state.subscriptionPrivileges = action.payload;
      }
    },
    resetFISubscriptionPrivileges: (state) => {
      state.FISubscriptionPrivileges = null;
    },
    clearPrivileges: (state) => {
      state.list = [];
      state.rbacPrivileges = [];
      state.subscriptionPrivileges = [];
      state.FISubscriptionPrivileges = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFISubscriptionPrivileges.pending, (_state, _action) => {
        _state.FISubscriptionPrivileges = {
          isLoading: true,
        };
      })
      .addCase(fetchFISubscriptionPrivileges.fulfilled, (_state, _action) => {
        _state.FISubscriptionPrivileges = {
          data: _action?.payload?.data,
          isLoading: false,
        };
      })
      .addCase(fetchFISubscriptionPrivileges.rejected, (_state, _action) => {
        _state.FISubscriptionPrivileges = {
          isLoading: false,
        };
      });
  },
});

export const {
  setRbacPrivileges,
  setSubscriptionPrivileges,
  clearPrivileges,
  resetFISubscriptionPrivileges,
} = privilegesSlice.actions;
export default privilegesSlice.reducer;
